import { useStorageSelectors } from "../../../../../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppDispatch } from "../../../../../../services/redux/hooks/use-dispatch";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { AppSwitch } from "../../../../../../shared/components/AppSwitch";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { TableIcon } from "../../../../../../shared/icons/TableIcon";
import { CaseTabs } from "../CaseTabs";
import { useCaseCreatorHeader } from "../../../../hook/use-case-creator-header";
import styles from "./styles.module.css";
import { DownloadIcon } from "../../../../../../shared/icons/DownloadIcon";
import { useAppModals } from "../../../../../../app/state/modalSlice/hook/use-app-modals";
import { PreviewMarkdownModal } from "../PreviewMarkdownModal";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectCaseValid } from "../../../../redux/selectors";

export const CaseCreatorHeader = () => {
  const {
    isLocked,
    entityMode,
    handleChangeCaseStateMode,
    handleChangeCaseMode,
    handleFreezeCase,
  } = useCaseCreatorHeader();
  const caseSolutionValid = useAppSelector(selectCaseValid);
  const { handleCloseModal, handleOpenModal } = useAppModals();
  return (
    <AppUnderlinedTitle
      leftContent={
        <CaseTabs value={entityMode} onChange={handleChangeCaseStateMode} />
      }
      className={styles["block-header"]}
    >
      <div className={styles["actions-container"]}>
        <div className={styles["switch-container"]}>
          <div>Заморозить</div>
          <AppSwitch checked={isLocked} onChange={handleFreezeCase} />
        </div>
        <AppIconButton
          onClick={() => handleOpenModal("preview_markdown_modal", null)}
          disabled={!caseSolutionValid}
        >
          <DownloadIcon />
        </AppIconButton>
        <AppIconButton onClick={handleChangeCaseMode}>
          <TableIcon />
        </AppIconButton>
      </div>
      <PreviewMarkdownModal closeModal={handleCloseModal} />
    </AppUnderlinedTitle>
  );
};
